<template>

    <div>
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">My Wallet</div>
            </base-header>
        </v-row>


        <v-row no-gutters>
            <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <div id="chart-spark1"></div>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <div id="chart-spark2"></div>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <div id="chart-spark3"></div>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <div id="chart-spark4"></div>
                    </div>
                </base-card>
            </v-col>
        </v-row>
       
        <v-row no-gutters>
             <v-col cols="6" sm="6">

                <card-money></card-money>
            </v-col>
           <v-col cols="6" sm="6">
                <card-transaction></card-transaction>
            </v-col>

            
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12">

                <card-tab></card-tab>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from "../../components/Base/BaseHeader.vue";
    import CardTab from '../../components/Cards/CardTab'
    import CardTransaction from '../../components/Cards/CardTransaction'
import CardMoney from '../../components/Cards/CardMoney.vue'
    import CardExchange from '../../components/Cards/CardExchange'
    import CardOrderbook from '../../components/Cards/CardOrderbook'
    export default {
        components: {
            BaseCard,
            CardTab,
            CardTransaction,
            CardMoney,
            CardExchange,
            CardOrderbook,
            BaseHeader


        },
        mounted() {

            var randomizeArray = function (arg) {
                var array = arg.slice();
                var currentIndex = array.length,
                    temporaryValue, randomIndex;

                while (0 !== currentIndex) {

                    randomIndex = Math.floor(Math.random() * currentIndex);
                    currentIndex -= 1;

                    temporaryValue = array[currentIndex];
                    array[currentIndex] = array[randomIndex];
                    array[randomIndex] = temporaryValue;
                }

                return array;
            }

            // data for the sparklines that appear below header area
            var sparklineData = [47, 45, 54, 38, 56, 24, 65, 31, 37, 39, 62, 51, 35, 41, 35, 27, 93, 53, 61, 27, 54, 43,
                19, 46
            ];
            var options = {
                series: [{
                    data: randomizeArray(sparklineData)
                }],
                chart: {
                    type: 'area',
                    height: 160,
                    sparkline: {
                        enabled: true
                    },
                },
                tooltip: {
                    theme: "dark"
                },
                stroke: {
                    curve: 'straight'
                },
                fill: {
                    opacity: 0.3,
                },
                yaxis: {
                    min: 0
                },
                colors: ['#ff0000'],
                title: {
                    text: '$424,652',
                    offsetX: 0,
                    style: {
                        fontSize: '24px',
                        color: '#ff0000'
                    }
                },
                subtitle: {
                    text: 'Sales',
                    offsetX: 0,
                    style: {
                        fontSize: '14px',
                        color: '#ff0000'
                    }
                }
            };

            var chart = new ApexCharts(document.querySelector("#chart-spark1"), options);
            chart.render();

            var optionsSpark2 = {
                series: [{
                    data: randomizeArray(sparklineData)
                }],
                chart: {
                    type: 'area',
                    height: 160,
                    sparkline: {
                        enabled: true
                    },
                },
                tooltip: {
                    theme: "dark"
                },
                stroke: {
                    curve: 'straight'
                },
                fill: {
                    opacity: 0.3,
                },
                yaxis: {
                    min: 0
                },
                colors: ['#74d680'],
                title: {
                    text: '$235,312',
                    offsetX: 0,
                    style: {
                        fontSize: '24px',
                        color: '#74d680'
                    }
                },
                subtitle: {
                    text: 'Expenses',
                    offsetX: 0,
                    style: {
                        fontSize: '14px',
                        color: '#74d680'
                    }
                }
            };

            var chartSpark2 = new ApexCharts(document.querySelector("#chart-spark2"), optionsSpark2);
            chartSpark2.render();

            var optionsSpark3 = {
                series: [{
                    data: randomizeArray(sparklineData)
                }],
                chart: {
                    type: 'area',
                    height: 160,
                    sparkline: {
                        enabled: true
                    },

                },
                tooltip: {
                    theme: "dark"
                },
                stroke: {
                    curve: 'straight'
                },
                fill: {
                    opacity: 0.1
                },
                xaxis: {
                    crosshairs: {
                        width: 1
                    },
                },
                yaxis: {
                    min: 0
                },
                colors: ['#74d680'],
                title: {
                    text: '$135,965',
                    offsetX: 0,
                    style: {
                        fontSize: '24px',
                        color: '#74d680'
                    }
                },
                subtitle: {
                    text: 'Profits',
                    offsetX: 0,
                    style: {
                        fontSize: '14px',
                        color: '#74d680'
                    }
                }
            };

            var chartSpark3 = new ApexCharts(document.querySelector("#chart-spark3"), optionsSpark3);
            chartSpark3.render();
            var optionsSpark4 = {
                series: [{
                    data: randomizeArray(sparklineData)
                }],
                chart: {
                    type: 'area',
                    height: 160,
                    sparkline: {
                        enabled: true
                    },
                },
                tooltip: {
                    theme: "dark"
                },
                stroke: {
                    curve: 'straight'
                },
                fill: {
                    opacity: 0.3,
                },
                yaxis: {
                    min: 0
                },
                colors: ['#ff0000'],
                title: {
                    text: '$424,652',
                    offsetX: 0,
                    style: {
                        fontSize: '24px',
                        color: '#ff0000'
                    }
                },
                subtitle: {
                    text: 'Sales',
                    offsetX: 0,
                    style: {
                        fontSize: '14px',
                        color: '#ff0000'
                    }
                }
            };

            var chartSpark4 = new ApexCharts(document.querySelector("#chart-spark4"), optionsSpark4);
            chartSpark4.render();
        },
    }
</script>